import React from 'react';
import './Awards.css';
import { FaLink } from 'react-icons/fa';

const awardsData = [
  {
    title: "MIRU Audience Award & Student Encouragement Award",
    // description: "Meeting on Image Recognition and Understanding",
    date: "August 2025",
    venue: "MIRU2025",
    link: {
      label: "Details",
      url: "https://cvim.ipsj.or.jp/MIRU2025/award-en.html",
    },
  },
  {
    title: "MIRU Interactive Presentation Award",
    // description: "Meeting on Image Recognition and Understanding",
    date: "August 2024",
    venue: "MIRU2024",
    link: {
      label: "Details",
      url: "https://miru-committee.github.io/miru2024/en/author/award/",
    },
  },
];

const Awards = () => (
  <section id="awards" className="awards-section">
    <h2>Awards</h2>
    <div className="awards-list">
      {awardsData.map((award, index) => (
        <div key={index} className="award-card">
          <h4 className="award-title">{award.title}</h4>
          <p className="award-description">{award.description}</p>
          <p className="award-meta">
            <span className="award-date">{award.date}</span> |{" "}
            <span className="award-venue">{award.venue}</span>
            {award.link && (
              <a
                href={award.link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="award-link about-button"
              >
                <FaLink /> {award.link.label}
              </a>
            )}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default Awards;
